/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'

import { Flex } from '../../../components/Layout'
import { border } from '../../../components/css'
import { media } from '../../../components/Responsive'
import { NewSelect } from '../../../components/List/RosterSelect'
import { TOURNAMENT_STATUS_TO_STRING } from './constants'

const BracketFilter = ({
  comps = [],
  setSelectedComp,
  selectedComp,
  competitionType,
  children,
}) => {
  if (!competitionType) {
    console.log('[error] no competitionType provided')
    return false
  }

  const getSubTitle = (option) => {
    let subTitle = `${option.count} Teams - ${
      TOURNAMENT_STATUS_TO_STRING[option.tournament_status]
    }`
    return subTitle
  }

  return (
    <Flex
      className='schedule-filters'
      alignItems='flex-end'
      css={css`
        padding-bottom: 20px;
        margin: 20px 0;
        border-bottom: ${border};
        width: 120%;
      `}
    >
      <Flex
        noFlex
        css={css`
          ${media.mobile} {
            flex-direction: column;
          }
        `}
      >
        <NewSelect
          label={competitionType}
          options={comps}
          selectedOptionId={selectedComp}
          onClick={(comp) => {
            setSelectedComp(comp)
          }}
          getTitle={(c) => c?.name_full || c?.name}
          getSubTitle={getSubTitle}
        />
      </Flex>
      {children}
    </Flex>
  )
}

export default BracketFilter
